import { useIdentityQueueStore } from "@/stores/identityQueueStore";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";

import useModalActions from "@/composables/store/modal/useModalActions";
import useGlobalRouterActions from "@/composables/store/global/useGlobalRouterActions";
import useProgressBarActions from "@/composables/progress/useProgressBarActions";

const { showSuccessModal } = useModalActions();
const { useLoadingStateAction } = useGlobalRouterActions();
const { updateToComplete } = useProgressBarActions();
let hasHitBackButton = false;

export default function useBeforeEach() {
  const handleSuccessModal = (to, from, next) => {
    if (to.path.includes("error")) {
      return;
    }

    if (
      from.path.includes("/verification/code") &&
      !from.path.includes("/identity") && // handle back event
      !to.path.includes("verification") // handle back event
    ) {
      showSuccessModal({ progressLevel: "Verification" });
    } else if (
      from.path === '/verification' && 
      to.path.includes("identity")
    ) {
      updateToComplete(["verification"]);
      showSuccessModal({ progressLevel: "Verification" });
    } else if (
      from.path.includes("identity") &&
      !to.path.includes("identity") &&
      to.path.includes("/payment") &&
      !to.path.includes("/verification/code") // handle back event
    ) {
      showSuccessModal({ progressLevel: "Identity" });
    } else if (from.path.includes("/payment") && to.path.includes("/status")) {
      showSuccessModal({ progressLevel: "Payment" });
    }

    next();
  };

  const handleIdentityKycPathings = async (to, from, next) => {
    const identityQueueStore = useIdentityQueueStore();
    const handleBackButton = () => {
      // we need to handle for dev only when page hot reloads and the state is back to 0
      if (identityQueueStore.queueCounter === 0) {
        identityQueueStore.queueCounter = 1;
      }

      // the popstate event was triggering back button twice
      if (identityQueueStore.queueCounter >= 2 && !hasHitBackButton) {
        hasHitBackButton = true;
        identityQueueStore.updateToPreviousRoute();
      }
      // else if (findIndex > -1 && findIndex <= identityQueueStore.totalSteps) {
      //   identityQueueStore.queueCounter = findIndex + 1;
      // }
    };

    const handleForwardButton = () => {
      if (identityQueueStore.queueCounter <= identityQueueStore.currentStep) {
        identityQueueStore.updateToNextRoute();
      }
    };

    if (to.path.includes("error")) {
      next();
      return;
    }

    if (!to.path.includes("identity") && !to.path.includes("payment")) {
      identityQueueStore.resetCounter();
      identityQueueStore.resetSteps();
      if (localStorage.getItem("identityRoutes")) {
        localStorage.removeItem("identityRoutes");
      }
      next();
      return;
    }

    if (to.path.includes("identity")) {
      // await identityQueueStore.fetchIdentityDocuments(from.path);
      window.addEventListener("popstate", handleBackButton, { once: true });
      // identityQueueStore.calculateTotalSteps();
      hasHitBackButton = false;
    }
  };

  const resetLoadingButtonState = (to, from, next) => {
    useLoadingStateAction(false);
  };

  return {
    handleSuccessModal,
    handleIdentityKycPathings,
    resetLoadingButtonState,
  };
}
